// extracted by mini-css-extract-plugin
export default {"tag":"environment-tag_tag__oEC5G"};